import React, { useEffect, useState } from 'react';
import '../Assets/CSS/BlogPage.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useParams } from 'react-router-dom';
import ContactUs from '../sections/home/Contactus';
import { getCookie } from '../components/auth/login/GetCookie';

const BlogDetailPage = () => {
      // Helper function to get cookie value
//   const getCookie = (name) => {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(";").shift();
//   };
    const { blogId } = useParams();
    const [loading,setLoading]=useState(false);
    const [blog, setBlog] = useState([]); // Retrieve the id from the URL parameters
    const [allblogs, setAllBlogs] = useState([]);
    console.log(blogId);
    useEffect(() => {
        window.scrollTo(0, 10); // Scroll to the top whenever blogId changes
        fetchData();
        fetchBlogs();
    }, [blogId]);  // Depend on blogId to trigger this effect when navigating to a different blog

    const fetchBlogs = async () => {
        setLoading(true);
        try {
            // await new Promise(res => setTimeout(res, 2000)); // simulate delay

            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/blog/allblogs`,
            );
            const data = await response.json();
            setAllBlogs(data);
            console.log(data);

        } catch (error) {
            console.error("Error fetching daily attendance data:", error);
        }
        finally{
            setLoading(false);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            // await new Promise(res => setTimeout(res, 2000)); // simulate delay

            // const token = localStorage.getItem("token"); // Assuming the token is stored in localStorage
    const token = getCookie("token");
            const response = await fetch
            (`${process.env.REACT_APP_BACKEND_URL}/api/v1/blog/${blogId}`, {
                method: 'GET', // Default method for fetch
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add Bearer token here
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setBlog(data);
            console.log(data);
        } catch (error) {
            console.error("Failed to fetch data", error);
        }
        finally{
            setLoading(false);
        }
    };

    if (!blog) {
        return <p>Blog not found</p>;
    }
    const renderSkeleton = () => (
        <div className="container my-5">
            <div className="skeleton-loader rounded mb-4" style={{ width: '100%', height: '400px', backgroundColor: '#eee' }} />
            <div className="skeleton-loader mb-2" style={{ width: '60%', height: '25px', backgroundColor: '#ddd' }} />
            <div className="skeleton-loader mb-2" style={{ width: '80%', height: '20px', backgroundColor: '#eee' }} />
            <div className="skeleton-loader mb-2" style={{ width: '90%', height: '20px', backgroundColor: '#eee' }} />
            <div className="skeleton-loader mb-2" style={{ width: '85%', height: '20px', backgroundColor: '#eee' }} />
        </div>
    );

    return (
        <div className='common-margin'>
            <div className='container-fluid h-[100vh]'>
            
                   
                <div className='row'>
                    <div className='col-md-12 bannerimg pb-4'>
                        <h1 className='blog-heading p-2 mt-3'>
                                                <Link to='/' className='text-white text-decoration-none'>
                                                    <Icon icon="iconamoon:home-thin" className='fs-4 pb-1 me-1' />
                                                </Link>
                                                <Link to='/blogs' className='text-white text-decoration-none'>
                                                    <Icon icon="weui:arrow-outlined" className='fs-3 pb-1  me-1' />
                                                    <span className='fs-6 me-1'>Blogs</span>
                                                </Link>
                                                <Icon icon="weui:arrow-outlined" className='fs-3 pb-1 me-1' />
                                                {blog.blogTitle}
                                            </h1>
                        <h1 className='blog-headingtwo'>{blog.blogTitle}</h1>
                        <div className='row ms-3'>
                            <div className='col-lg-3 col-md-4 col-sm-12 d-flex justify-content-between align-items-center'>
                                <p className='eventer-name mb-0 text-start'>{blog.createdBy}</p>
                                <p className='event-Detail-date mb-0 text-end'>{new Date(blog.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</p>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className='container'>
                {loading || !blog ? (
                    renderSkeleton()
                ) : (
                    <>
                    <div className='blog-detail'>
                        <div className='row mt-5'>
                            <div className='col-lg-12 col-md-12 col-sm-12 mb-4'>
                                <img src={blog.blogImage} alt={blog.blogId} className=' rounded-3' 
                                style={{
                                    width:'800px',
                                    height: '450px'
                                }} />
                                <h6 className='blog-span text-center mt-3'>{blog.blogTitle}</h6>
                                <p className='blog-para mt-4 mb-5 text-left'>
                                    {blog.blogDescription}
                                    {/* Add more detailed blog content here */}
                                </p>
                            </div>
                        </div>
                    </div>
                    </>
                )}
                    <div className='other-blog'>
                        <h1 className='other-blog-heading' style={{ color: '#303030' }}>Other Blogs:</h1>
                        <div className='row'>
                        {loading
            ? [...Array(3)].map((_, index) => (
                <div key={index} className='col-lg-4 col-md-12 col-sm-12 mb-5'>
                    <div className='blogCard skeleton-card p-3'>
                        <div
                            className='skeleton skeleton-img rounded-4 mb-3'
                            style={{ width: '100%', height: '250px' }}
                        />
                        <div className='skeleton skeleton-text w-75 mb-2' style={{ height: '20px' }} />
                        <div className='skeleton skeleton-text w-100 mb-2' style={{ height: '16px' }} />
                        <div className='skeleton skeleton-text w-50' style={{ height: '14px' }} />
                    </div>
                </div>
            )):
                            allblogs
                                .filter((blog) => blog.blogId != blogId) // Filter out the blog matching blogId
                                .slice(0, 3) // Take the first three after filtering
                                .map((blog) => (
                                    <div key={blog.blogId} className='col-lg-4 col-md-12 col-sm-12'>
                                        <Link to={`/blogdetail/${blog.blogId}`} className="text-decoration-none text-dark">
                                            <div className='blogCard mb-5' style={{ cursor: 'pointer' }}>
                                                <img
                                                    src={blog.blogImage[0]}
                                                    alt={`blog${blog.blogId}`}
                                                    className='img-fluid overflow-hidden rounded-4'
                                                    style={{ height: '250px', width: '350px',
                                                       
                                                     }}
                                                />
                                                <h5 className='card-title pt-2'>{blog.blogTitle}</h5>
                                                <p className='card-text pt-1'>{blog.blogDescription.slice(0, 80)}<span>...</span></p>
                                                <small className='text-muted'>{new Date(blog.createdAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</small>
                                            </div>
                                        </Link>
                                    </div>
                                ))}


                        </div>
                    </div>
                </div>
               
            </div>
            <ContactUs />
        </div>
    );
};

export default BlogDetailPage;
